/**
 * Pebbles API service
 * Handles HTTP requests to the user profile endpoint
 */

import { api } from '@/lib/api';
import type { UserProfile } from '@/types/pebbles';

/**
 * Fetch the authenticated user's profile including Pebbles count
 * @returns Promise resolving to UserProfile object
 */
export async function getUserProfile(): Promise<UserProfile> {
  const response = await api.get<UserProfile>('/users/me');
  return response.data;
}
